"use client";

import { Suspense } from "react";
import ReferralLoginForm from "./ReferralLoginForm";

// Wrap the form in Suspense to handle useSearchParams()
export default function ReferralLoginPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ReferralLoginForm />
    </Suspense>
  );
}

